import { computed }          from 'mobx';
import NewFondationsApiModel from 'models/global/NewFondationsApiModel';

export default class EntityAddressModel extends NewFondationsApiModel {
	static get path(): string {
		return '/addresses/{?id}';
	}

	@computed
	public get addressName() {
		return this.get('name');
	}

	@computed
	public get addressLine() {
		return this.get('addressLine');
	}

	@computed
	public get addressLineBis() {
		return this.get('addressLineBis');
	}

	@computed
	public get zipcode() {
		return this.get('zipcode');
	}

	@computed
	public get city() {
		return this.get('city');
	}

	@computed
	public get region() {
		return this.get('region');
	}

	@computed
	public get country() {
		return this.get('country');
	}
}
